import React from 'react';
import { useAuthStore } from '../features/auth/authStore';

export const AuthDebug: React.FC = () => {
  const { user, tenant, accessToken, isAuthenticated } = useAuthStore();

  // Always show in development (Vite uses import.meta.env)
  const isDevelopment = import.meta.env?.DEV || import.meta.env?.MODE === 'development' || process.env.NODE_ENV === 'development';

  if (!isDevelopment) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 bg-black bg-opacity-75 text-white p-4 rounded-lg text-xs max-w-sm">
      <h4 className="font-bold mb-2">Auth Debug</h4>
      <div className="space-y-1">
        <div>Authenticated: {isAuthenticated ? '✅' : '❌'}</div>
        <div>User: {user?.email || 'None'}</div>
        <div>Firm: {tenant?.subdomain || 'None'}</div>
        <div>Token: {accessToken ? '✅' : '❌'}</div>
        <div>Roles: {user?.roles?.join(', ') || 'None'}</div>
      </div>
    </div>
  );
};
